module.exports = __webpack_public_path__ + "img/ambassador-1.1a50e23b.png";